import React, { useState, useEffect } from "react";
import { LazyLoadImage } from "../LazyLoadImage/LazyLoadImage";
import { HeadingWithDescription } from "../Heading/HeadingWithDescription";
import { ShowMoreButton } from "../ShowMoreButton/ShowMoreButton";

import "./ItineraryDay.scss";

export interface ItineraryDay {
  date: string;
  imageDescription: string;
  day: IItineraryDaySummary;

  /**
   * A boolean can be passed by a parent component to
   * open or close the expanded area
   */
  isExpanded?: boolean;
  onClick?: (isExpanded: boolean) => void;
}

/**
 * Itinerary Day with optional expanding content
 *
 * @status stable
 */
export const ItineraryDay: React.FC<ItineraryDay> = (props) => {
  const [expanded, setExpanded] = useState<boolean>(props.isExpanded || false);

  useEffect(() => {
    setExpanded(props.isExpanded || false);
  }, [props.isExpanded])

  return (
    <div className="itinerary-day">
      <div className="itinerary-day__summary columns is-marginless">
        {props.day.image &&
          <div className="itinerary-day__image column is-paddingless is-half-tablet">
            <LazyLoadImage src={props.day.image} alt={props.imageDescription} />
          </div>
        }
        <div className="itinerary-day__content column is-half-tablet">
          <div className="itinerary-day__content-inner">
            <div className="m-bottom-small">
              <h3 className="m-bottom-xsmall">
                Day {props.day.dayNumber} { props.day.locationNames.length !== 0 && `- ${props.day.locationNames.join(", ")}` }
              </h3>
              {props.date && <p className="text--label is-marginless">{props.date}</p>}
            </div>
            {props.day.events.length > 0 &&
              <ul>
                {props.day.events.map((event, index) =>
                  <li key={`exn_${index}`}> {event.name}</li>
                )}
              </ul>
            }
          </div>
          {props.children &&
            <ShowMoreButton
              isOpen={expanded}
              onClick={() => {
                setExpanded(!expanded)
                props.onClick?.(expanded);
              }}
            />
          }
        </div>
      </div>
      {expanded && props.children &&
        <>
          {props.children}
          <div className="itinerary-day__button-bottom">
            <ShowMoreButton
              isOpen={expanded}
              onClick={() => {
                setExpanded(!expanded)
                props.onClick?.(expanded);
              }}
            />
          </div>
        </>
      }
    </div>
  )
}

ItineraryDay.defaultProps = {
  isExpanded: false,
}
